/**
 *
 * Asynchronously loads the component for RootPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
